import type React from 'react'

import { Button, AlternateButton } from '@/components/DEPRECATED_UI/Button'

interface Props {
  onYes: () => void
  onNo: () => void
  onClose: () => void
  isLandlordDifferent: boolean
}

const ConfirmationFooter: React.FC<Props> = ({
  onYes,
  onNo,
  onClose,
  isLandlordDifferent,
}) => {
  return (
    <>
      {isLandlordDifferent ? (
        <>
          <AlternateButton onClick={onClose}>Close</AlternateButton>
        </>
      ) : (
        <>
          <AlternateButton onClick={onNo}>No</AlternateButton>
          <Button onClick={onYes}>Yes</Button>
        </>
      )}
    </>
  )
}

export default ConfirmationFooter
